var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",on:{"click":_vm.close}},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""},on:{"click":function($event){$event.stopPropagation();}}})])}
var staticRenderFns = []

export { render, staticRenderFns }